// src/components/PrivateRoute.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.collegeAuth.isAuthenticated); // Accessing the auth state from Redux

  return isAuthenticated ? children: children
};

export default PrivateRoute;